import { axiosGet } from '@/API/API';
import NotifCard from '@/components/notifCard/NotifCard';
import { setNotifs } from '@/store/notifSlice';
import { useAppDispatch, useAppSelector } from '@/store/reduxHooks';
import useTablePagination from '@/utils/useTablePagination';

import { useEffect, useState } from 'react';

import {
	Breadcrumb,
	BreadcrumbContainer,
	Card,
	TableNextPage,
	TablePage,
	TablePreviousPage,
} from '@sobrus-com/sobrus-design-system-v2';

import './style.scss';

const Notifications = () => {
	const dispatch = useAppDispatch();
	const notifs = useAppSelector((state) => state.notif.notifs);
	const [data, setData] = useState<any>(notifs?.notifications);
	const [isFetching, setIsFetching] = useState(true);

	const { pageNumber, setPageNumber, prevPage, nextPage } = useTablePagination(data, () => {}, setIsFetching);

	useEffect(() => {
		if (notifs?.notifications && notifs.notifications.length > 0) {
			setData(notifs.notifications);
		}
	}, [notifs]);

	useEffect(() => {
		if (isFetching) {
			axiosGet<any>(`api/notifications?limit=15&page=${pageNumber}`).then((res) => {
				if (res?.data) {
					dispatch(setNotifs(res.data));
					setData(res.data.notifications);
				}
				setIsFetching(false);
			});
		}
	}, [isFetching, pageNumber, dispatch]);

	return (
		<section className="sns-wrapper">
			<BreadcrumbContainer>
				<Breadcrumb title="Liste des notifications" subTitle="Notifications" />
			</BreadcrumbContainer>
			<Card>
				{data?.length > 0 &&
					data.map((ele: any) => (
						<NotifCard
							key={ele?.id}
							notifId={ele?.id}
							isSeen={ele?.isSeen}
							isClicked={ele?.isClicked}
							content={ele?.content}
							context={ele?.context}
							action={ele?.action}
							resourceId={ele?.resourceId}
							time={ele?.createdAt}
						/>
					))}
				<div className="notifications-paging">
					<TablePreviousPage disabled={pageNumber <= 1} onClick={prevPage} />
					<TablePage>{pageNumber}</TablePage>
					<TableNextPage disabled={!data || data?.length < 15} onClick={nextPage} />
				</div>
			</Card>
		</section>
	);
};

export default Notifications;
